// extracted by mini-css-extract-plugin
export default {"item":"Item_item__obtBB","counter":"Item_counter__xob9s","balance":"Item_balance__h2VmM"};